import { memo } from "react"
import { useAllProducts } from "../../hooks/products"
import { Center, Checkbox, Spinner, Stack, Text } from "@chakra-ui/react"

const ProductSelect = ({ selected, setSelected }) => {
  const { products, isLoading } = useAllProducts()

  return (
    <Stack
      spacing={4}
      p={4}
      border="1px"
      borderColor="gray.200"
      borderRadius="md"
    >
      {isLoading ? (
        <Center p={16}>
          <Spinner />
        </Center>
      ) : (
        products.map((product) => (
          <Checkbox
            key={product.id}
            isChecked={selected.includes(product.id)}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              e.stopPropagation()
              setSelected(
                e.target.checked
                  ? [...selected, product.id]
                  : selected.filter((e) => e !== product.id)
              )
            }}
          >
            <Text fontSize="sm">{product.name}</Text>
          </Checkbox>
        ))
      )}
    </Stack>
  )
}

export default memo(ProductSelect)
